'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getToggleBlockStyleFunc;

var _draftJs = require('draft-js');

var _getSelectedBlock = require('./getSelectedBlock');

var _getSelectedBlock2 = _interopRequireDefault(_getSelectedBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getToggleBlockStyleFunc(callbacks) {
    return function toggleBlockStyle(styleName) {
        var getEditorState = callbacks.getEditorState;
        var setEditorState = callbacks.setEditorState;

        var editorState = getEditorState();
        var currentBlock = (0, _getSelectedBlock2["default"])(editorState);
        var blockTypedContent = _draftJs.Modifier.setBlockType(editorState.getCurrentContent(), editorState.getSelection(), styleName);
        setEditorState(_draftJs.EditorState.push(editorState, blockTypedContent, 'apply-block-type'));
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/.0.1.0@rc-editor-utils/lib/getToggleBlockStyleFunc.js
// module id = 324
// module chunks = 0